import { apiGetUserCart, apiGetPricingSummary, apiGetNextOrderDates, apiGetItNow, resumeSubscription, apiUpdateItemQuantity, apiPrecalculateOrder, } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import LoadProfileInfoThunk from "Root/profile/redux/thunkCreators/user/user";
import { uuid } from "Root/profile/utils";
import { setGinUserCart, setGinLoading, setGinDiscountStr, setGinRecurringDiscountStr, setGinPricingSummary, setGinNextOrder, setGlobalLoading, setHomeStoreAction, setHistoryStoreAction, } from "../../actionCreators/makeActionCreator";
import { LoadOrderStatusDataThunk } from "../orders/orderDetails";
import { LoadNextOrderDatesThunk } from "../orders/nextOrderDates";
import LoadReferalInfoThunk from "Root/profile/redux/thunkCreators/referalInfo/referalInfo";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
import { fetchSeasonalPromotion } from "../../slices/profileSeasonalPromotionSlice";
const sameAttributes = (attr1, attr2) => {
    const same = [];
    attr1.forEach((item, i) => {
        same.push(item.attribute_on === attr2[i].attribute_on);
    });
    return same.every((value) => !!value);
};
const groupBagsBy = (list) => {
    const groupedItems = list.reduce((grouped, bag) => {
        if (grouped.length === 0) {
            return [...grouped, bag];
        }
        let isRepeating = false;
        grouped.length &&
            grouped.forEach((item) => {
                if (item.selected_flavors.find((flavor) => !!flavor.count)
                    ?.short_name ===
                    bag?.selected_flavors.find((flavor) => !!flavor.count)
                        ?.short_name &&
                    sameAttributes(item.attributes, bag.attributes)) {
                    isRepeating = true;
                    item.quantity++;
                }
            });
        return isRepeating ? [...grouped] : [...grouped, bag];
    }, []);
    return groupedItems;
};
const addIdsToBags = (bags) => bags.map((item) => {
    if (item.bags_info) {
        return {
            ...item,
            bags_info: item.bags_info.map((bag) => ({
                ...bag,
                id: uuid(),
            })),
        };
    }
    return item;
});
export const LoadCurrentUserCartThunk = () => async (dispatch) => {
    try {
        const data = await apiGetUserCart().then((cart) => cart);
        const dataWithIds = addIdsToBags(data);
        dispatch(setGinUserCart(dataWithIds));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export const FetchPricingSummaryThunk = (flag) => async (dispatch) => {
    try {
        const data = await apiGetPricingSummary();
        if (flag === "discount_str") {
            dispatch(setGinRecurringDiscountStr(data.recurring_discount_str));
            dispatch(setGinDiscountStr(data.discount_str));
        }
        else if (flag === "pricing_sum") {
            dispatch(setGinPricingSummary(data.lineItems));
        }
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export const RecalculateOrderThunk = (cart) => async (dispatch) => {
    try {
        dispatch(setGlobalLoading(true));
        const data = await apiPrecalculateOrder(cart);
        dispatch(setGinPricingSummary(data));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
export const FetchNextOrderDataThunk = () => async (dispatch) => {
    try {
        const data = await apiGetNextOrderDates();
        dispatch(setGinNextOrder(data));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export const OnChangeQuantityThunk = (value, name, genericSku, bagId, productData) => async (dispatch, getState) => {
    try {
        dispatch(setGlobalLoading(true));
        if (value === 0 && getState().getItNow.userCart.length === 1) {
            toastService.errorMessage("You should keep at least one item");
            return;
        }
        if (value === 2 &&
            getState().ordersInfo.nextOrderDates.plan === "advantage") {
            if (!["hydration", "preworkout"].includes(name)) {
                toastService.errorMessage("Advantage Plan requires a minimum qty of 3 per product");
                return;
            }
        }
        const updatedUserCart = getState().getItNow.userCart.map((item) => {
            if (item.item_type === "additional_flavorboost") {
                return item.sku === genericSku
                    ? {
                        ...item,
                        quantity: Number(value),
                    }
                    : { ...item };
            }
            if (item.bags_info) {
                return {
                    ...item,
                    quantity: Number(value),
                    bags_info: item.bags_info.map((bag) => {
                        // sometimes both ids can be undefined and then all such items are added new quantity
                        if (bag.id && bagId && bag.id === bagId) {
                            return {
                                ...bag,
                                quantity: value,
                            };
                        }
                        return {
                            ...bag,
                            id: uuid(),
                        };
                    }),
                };
            }
            return item.item_type === name
                ? {
                    ...item,
                    quantity: Number(value),
                }
                : { ...item };
        });
        if (productData) {
            const updatedProduct = updatedUserCart.find((item) => item.item_type === productData.item_type);
        }
        else {
            const summary = await apiUpdateItemQuantity(updatedUserCart);
            dispatch(setGinPricingSummary(summary.lineItems));
            const summaryUserCartWithgIds = addIdsToBags(summary.user_cart);
            dispatch(setGinUserCart(summaryUserCartWithgIds));
        }
    }
    catch (e) {
        toastService.errorMessage("Something went wrong");
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
export const BuyNowThunkV2 = (history) => async (dispatch, getState) => {
    try {
        const cart = getState().getItNow.userCart;
        dispatch(setGlobalLoading(true));
        await apiGetItNow(cart);
        await dispatch(LoadOrderStatusDataThunk());
        await dispatch(LoadNextOrderDatesThunk());
        dispatch(setHomeStoreAction(true));
        dispatch(setHistoryStoreAction(true));
        dispatch(LoadReferalInfoThunk());
        dispatch(LoadPricingThunk());
        toastService.successMessage("Success! Your order was placed.");
        history.push("/app/home/");
    }
    catch (e) {
        const error = e.toString();
        if (error.length > 100) {
            toastService.errorMessage("Something went wrong");
        }
        else {
            toastService.errorMessage(e.toString());
        }
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
export const BuyNowThunk = (history, isReactivation, productData) => async (dispatch, getState) => {
    try {
        dispatch(setGlobalLoading(true));
        if (productData && !isReactivation) {
            await apiGetItNow(getState().getItNow.userCart);
            await dispatch(LoadOrderStatusDataThunk());
            await dispatch(LoadNextOrderDatesThunk());
            toastService.successMessage("Success");
        }
        else {
            const data = await resumeSubscription();
            if (data?.used_black_friday_promo_code) {
                localStorage.setItem("black_friday_promo_used", "1");
            }
            dispatch(fetchSeasonalPromotion());
            dispatch(LoadProfileInfoThunk());
            dispatch(LoadOrderStatusDataThunk());
            dispatch(LoadNextOrderDatesThunk());
            toastService.successMessage("Success! Your order was processed, and your subscription is active.");
        }
        dispatch(setHomeStoreAction(true));
        history.push("/app/home");
    }
    catch (e) {
        const error = e.toString();
        if (error.length > 100) {
            toastService.errorMessage("Something went wrong");
        }
        else {
            toastService.errorMessage(e.toString());
        }
        const fetchAllData = async () => {
            dispatch(setGinLoading(true));
            await Promise.all([
                dispatch(FetchPricingSummaryThunk("pricing_sum")),
                dispatch(LoadCurrentUserCartThunk()),
                dispatch(FetchNextOrderDataThunk()),
            ]);
            dispatch(setGinLoading(false));
        };
        await fetchAllData();
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
